function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M16 25a9 9 0 01-9-9 9 9 0 019-9 9 9 0 019 9 9 9 0 01-9 9z",
  fill: "#D4E1EE"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.661 19.669l5.421-5.423a1.082 1.082 0 00-1.529-1.53l-4.657 4.659-2.45-2.451a1.082 1.082 0 00-1.53 1.53l3.216 3.215a1.077 1.077 0 001.53 0z",
  fill: "#fff"
});

var SvgIconCirCheckUnhighlighted = function SvgIconCirCheckUnhighlighted(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE2IDI1QzExLjAyOTMgMjUgNyAyMC45NzA3IDcgMTZDNyAxMS4wMjkzIDExLjAyOTMgNyAxNiA3QzIwLjk3MDcgNyAyNSAxMS4wMjkzIDI1IDE2QzI1IDIwLjk3MDcgMjAuOTcwNyAyNSAxNiAyNVoiIGZpbGw9IiNENEUxRUUiLz4KPHBhdGggZD0iTTE1LjY2MTIgMTkuNjY4OUwyMS4wODI1IDE0LjI0NThDMjEuNTA2NSAxMy44MjM0IDIxLjUwNTQgMTMuMTM4NyAyMS4wODI1IDEyLjcxNjRDMjAuNjYxMyAxMi4yOTQ1IDE5Ljk3NTUgMTIuMjk0NSAxOS41NTM3IDEyLjcxNjRMMTQuODk2NSAxNy4zNzQ5TDEyLjQ0NjIgMTQuOTIzOUMxMi4wMjM4IDE0LjUwMjEgMTEuMzM4NyAxNC41MDIxIDEwLjkxNjkgMTQuOTIzOUMxMC40OTQ1IDE1LjM0NjMgMTAuNDk0NSAxNi4wMzIgMTAuOTE2OSAxNi40NTMzTDE0LjEzMTggMTkuNjY4OUMxNC4zNDMzIDE5Ljg4MDQgMTQuNjE5NiAxOS45ODU5IDE0Ljg5NjUgMTkuOTg1OUMxNS4xNzM0IDE5Ljk4NTkgMTUuNDQ5NyAxOS44ODA0IDE1LjY2MTIgMTkuNjY4OVoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";
export { SvgIconCirCheckUnhighlighted as ReactComponent };